import { useMemo } from 'react'

/**
 * Hook for detecting LG Smart TV devices
 * @returns {Object} Detection utilities and state
 */
export const useLGDetection = () => {
  /**
   * Detect if current device is an LG Smart TV
   * Uses user agent detection for webOS signature
   * @returns {boolean} true if device is LG Smart TV
   */
  const isLGSmartTV = useMemo(() => {
    if (typeof navigator === 'undefined') return false

    const userAgent = navigator.userAgent
    return (
      userAgent.includes('Web0S; Linux/SmartTV') ||
      userAgent.includes('webOSTV') ||
      (userAgent.includes('LGE') && userAgent.includes('webOS'))
    )
  }, [])

  /**
   * Get device type information
   * @returns {Object} Device type details
   */
  const getDeviceInfo = useMemo(() => {
    return {
      isLGTV: isLGSmartTV,
      deviceType: isLGSmartTV ? 'lg-smart-tv' : 'other',
      supportsWebOS: isLGSmartTV
    }
  }, [isLGSmartTV])

  /**
   * Check if device supports specific LG TV features
   * @returns {Object} Feature support flags
   */
  const getFeatureSupport = useMemo(() => {
    return {
      supportsWebOSAPI: isLGSmartTV && typeof global.webOS !== 'undefined',
      supportsPlatformBack: isLGSmartTV,
      supportsRemoteControl: isLGSmartTV
    }
  }, [isLGSmartTV])

  return {
    isLGSmartTV,
    getDeviceInfo,
    getFeatureSupport
  }
}
